
import { Calendar, Target, ChartBar } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CoreFeaturesSection = () => {
  const features = [
    {
      icon: Calendar,
      title: "Create & Manage Events",
      items: [
        "Set up an event in minutes – venue, date, time, and ticket tiers",
        "Sell tickets directly through ClubMate's marketplace",
        "Auto-generate QR codes for ticketing & entry management"
      ]
    },
    {
      icon: Target,
      title: "Targeted AI-Powered Marketing",
      items: [
        "AI automatically recommends events to the right audience",
        "Run exclusive VIP pre-sales and flash discounts",
        "Push notifications & social media integration"
      ]
    },
    {
      icon: ChartBar,
      title: "Real-Time Sales & Attendance",
      items: [
        "See live ticket sales & check-in data in one dashboard",
        "Track repeat attendees and offer loyalty perks",
        "Generate detailed post-event analytics"
      ]
    }
  ];

  return (
    <div className="py-24 px-6 bg-black/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16">
          Core Features Available Now
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(168,85,247,0.15)] group hover:shadow-[0_0_30px_rgba(168,85,247,0.25)] transition-all duration-300"
            >
              <feature.icon className="w-12 h-12 text-purple-400 mb-4 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="text-2xl font-semibold text-white mb-4">{feature.title}</h3>
              <ul className="space-y-3">
                {feature.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-2 text-gray-300">
                    <span className="h-2 w-2 mt-2 rounded-full bg-purple-400" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="text-center">
          <Button
            size="lg"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-full px-8 shadow-[0_0_30px_rgba(168,85,247,0.4)] hover:shadow-[0_0_30px_rgba(168,85,247,0.6)] transition-all duration-300"
          >
            List an Event & Start Selling Tickets
          </Button>
        </div>
      </div>
    </div>
  );
};
